import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["active", "children", "className", "color", "variant", "loading", "loadingAriaLabel", "disabled"];
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { CompositeItem, Button } from '@ariakit/react';
import { Gray05, Gray100, BoxBlue100, DarkBlue100, GreenLight100, Grimace100, Size4, Size6 } from '@box/blueprint-web-assets/tokens/tokens';
import clsx from 'clsx';
import Color from 'color';
import omit from 'lodash/omit';
import { forwardRef, createElement } from 'react';
import { Ghost } from '../../ghost/ghost.js';
import { Text } from '../../text/text.js';
import { Tooltip } from '../../tooltip/tooltip.js';
import styles from './select-menu-grid-option.module.js';
var SelectMenuGridSquare = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return jsx(SelectMenuGridOption, _objectSpread(_objectSpread({}, props), {}, {
    ref: forwardedRef,
    variant: "square"
  }));
});
var SelectMenuGridColorCircle = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return jsx(SelectMenuGridOption, _objectSpread(_objectSpread({}, props), {}, {
    ref: forwardedRef,
    variant: "colorCircle"
  }));
});
var SelectMenuGridWithLabel = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return jsx(SelectMenuGridOption, _objectSpread(_objectSpread({}, props), {}, {
    ref: forwardedRef,
    variant: "labeled"
  }));
});
var SelectMenuGridOption = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _clsx, _clsx2;

  var active = props.active,
      children = props.children,
      className = props.className,
      color = props.color,
      variant = props.variant,
      loading = props.loading,
      loadingAriaLabel = props.loadingAriaLabel,
      disabled = props.disabled,
      restProps = _objectWithoutProperties(props, _excluded);

  var isWithLabel = variant === 'labeled';
  var isButtonDisabled = disabled || loading;
  var isButtonActive = !disabled && !loading && active;
  var isButtonDragged = isWithLabel && !isButtonDisabled && props.draggable && props.dragging;
  var shouldShowTooltip = !isButtonDisabled && !isWithLabel;
  var ariaLabel = !isWithLabel ? props['aria-label'] : props.label;
  var buttonProps = isWithLabel ? omit(restProps, ['colorVariant', 'icon', 'dragging', 'label']) : restProps; // TODO: [DSYS-764] use IconButton instead of AriakitButton

  var button = jsx(CompositeItem, {
    render: jsxs(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
      ref: forwardedRef,
      "aria-label": loading ? loadingAriaLabel : ariaLabel,
      className: clsx(styles.optionButton, className, (_clsx = {}, _defineProperty(_clsx, styles.labeled, isWithLabel), _defineProperty(_clsx, styles.loading, loading), _defineProperty(_clsx, styles.active, isButtonActive), _defineProperty(_clsx, styles.dragging, isButtonDragged), _clsx)),
      disabled: isButtonDisabled,
      children: [variant === 'colorCircle' && jsx(ColorSwatch, {
        color: color || '',
        loading: !!loading
      }), variant === 'square' && jsx(Icon, {
        loading: !!loading,
        children: children
      }), variant === 'labeled' && jsx(ItemWithLabel, _objectSpread({}, props))]
    }))
  });
  return jsxs("div", {
    className: clsx(styles.buttonWrapper, (_clsx2 = {}, _defineProperty(_clsx2, styles.withLabel, isWithLabel), _defineProperty(_clsx2, styles['withLabel--default'], isWithLabel && props.size === 'default'), _clsx2)),
    role: "gridcell",
    children: [shouldShowTooltip && jsx(Tooltip, {
      __checkInteractivity: false,
      "aria-hidden": true,
      content: ariaLabel,
      side: props.tooltipSide,
      children: button
    }), !shouldShowTooltip && button]
  });
});

var ColorSwatch = function ColorSwatch(_ref) {
  var color = _ref.color,
      loading = _ref.loading;
  var isNoColorOption = color === 'no-color';
  var finalColor = isNoColorOption ? Gray05 : color;
  var borderColor = new Color(finalColor).darken(0.5).hex();
  var style = {
    '--circleColor': finalColor,
    '--circleBorderColor': borderColor
  };
  return jsx("div", {
    className: clsx(styles.circle, styles.outlineHost, _defineProperty({}, styles.loading, loading)),
    style: style,
    children: loading ? jsx(Ghost, {
      variant: "circle"
    }) : jsx("div", {
      className: clsx(styles.color, _defineProperty({}, styles.strikeThrough, isNoColorOption))
    })
  });
};

var Icon = function Icon(_ref2) {
  var children = _ref2.children,
      loading = _ref2.loading;
  return jsx("div", {
    className: clsx(styles.square),
    children: jsx("div", {
      className: styles.outlineHost,
      children: loading ? jsx(Ghost, {
        variant: "circle"
      }) : children
    })
  });
};

var iconColor = {
  default: Gray100,
  box: BoxBlue100,
  sign: DarkBlue100,
  forms: GreenLight100,
  docgen: Grimace100
};
var iconSize = {
  default: Size4,
  large: Size6
};

var ItemWithLabel = function ItemWithLabel(_ref3) {
  var size = _ref3.size,
      colorVariant = _ref3.colorVariant,
      label = _ref3.label,
      icon = _ref3.icon;
  var iconElement = /*#__PURE__*/createElement(icon, {
    color: iconColor[colorVariant],
    width: iconSize[size],
    height: iconSize[size],
    role: 'presentation'
  });
  return jsxs(Fragment, {
    children: [jsx("div", {
      className: clsx(styles.iconContainer, styles["iconContainer--".concat(colorVariant)], styles["iconContainer--size-".concat(size)]),
      children: iconElement
    }), jsx(Text, {
      as: "span",
      className: clsx(styles.text, styles["text--".concat(size)]),
      variant: size === 'default' ? 'caption' : 'bodyDefaultBold',
      children: label
    })]
  });
};

export { ItemWithLabel, SelectMenuGridColorCircle, SelectMenuGridOption, SelectMenuGridSquare, SelectMenuGridWithLabel };